// angular import
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Project import
import { AdminComponent } from './theme/layouts/admin-layout/admin-layout.component';
import { GuestLayoutComponent } from './theme/layouts/guest-layout/guest-layout.component';
import { AuthGuard } from './guards/auth-guard';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    canActivate: [AuthGuard], // ✅ protect admin layout
    children: [
      {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
      },
      {
        path: 'dashboard/default',
        loadComponent: () => import('./demo/dashboard/default/default.component').then((c) => c.DefaultComponent)
      },
            {
        path: 'dashboard/teacher',
        loadComponent: () => import('./demo/dashboard/teacher/teacher').then((c) => c.Teacher)
      },
      {
        path: 'typography',
        loadComponent: () => import('./demo/component/basic-component/typography/typography.component').then((c) => c.TypographyComponent)
      },
      {
        path: 'color',
        loadComponent: () => import('./demo/component/basic-component/color/color.component').then((c) => c.ColorComponent)
      },
      {
        path: 'sample-page',
        loadComponent: () => import('./demo/others/sample-page/sample-page.component').then((c) => c.SamplePageComponent)
      },
       {
        path: 'catalogos',
        loadComponent: () => import('./demo/component/catalogos/catalogos').then((c) => c.Catalogos)
      },
      {path: 'inscripcion',
        loadComponent: () => import('./demo/component/estudiantes/estudiantes').then((c) => c.Estudiantes)
      },
      {
        path:'alumnos',
        loadComponent: () => import('./demo/component/listalumnos/listalumnos').then((c) => c.Listalumnos)
      },
      {path: 'newuser',
        loadComponent: () => import('./demo/component/newuser/newuser').then((c) => c.Newuser)
      },
      {path:'usuarios',
        loadComponent: () => import('./demo/component/users/users').then((c) => c.Users)
      },
      {path:'docentes',
        loadComponent: () => import('./demo/component/listteachers/listteachers').then((c) => c.Listteachers)
      },
      {path:'teacher',
        loadComponent: () => import('./demo/component/teacher/teacher').then((c) => c.Teacher)
      },
      {path:'grouplist',
        loadComponent: () => import('./demo/component/grupodetails/grupodetails').then((gl)=> gl.Grupodetails )
      },
      {path: 'studentdetail',
        loadComponent: () => import('./demo/component/estudiantes/estudiantes').then((c) => c.Estudiantes)
      },
         {path: 'calendar',
        loadComponent: () => import('./demo/component/calendar/calendar.component').then((c) => c.CalendarComponent)
      },
        {path: 'notify',
        loadComponent: () => import('./demo/component/notybar/notybar').then((c) => c.NotybarComponent)
      },
        {path: 'listgroups',
        loadComponent: () => import('./demo/component/gruposlist/gruposlist').then((c) => c.Gruposlist)
      },
        {path: 'frashman',
        loadComponent: () => import('./demo/component/frashman/frashman').then((c) => c.Frashman)
      },
        {path: 'weekly',
        loadComponent: () => import('./demo/component/weeklycal/weeklycal').then((c) => c.Weeklycal)
      },
      {path:'pagos',
                loadComponent: () => import('./demo/component/pendientes-pago/pendientes-pago').then((c) => c.PendientesPago)
      },
        {path:'demos',
                loadComponent: () => import('./demo/component/demo-assigned/demo-assigned').then((c) => c.DemoAssigned)
      },
        {path:'logs',
                loadComponent: () => import('./demo/components/access-stats/access-stats').then((c) => c.AccessStats)
      },
        {path:'dias',
                loadComponent: () => import('./demo/components/select-days/select-days').then((c) => c.SelectDays)
      },
        {path:'aperturas',
                loadComponent: () => import('./demo/component/aperturas/aperturas').then((c) => c.Aperturas)
      },
        {path:'messages',
                loadComponent: () => import('./demo/component/messages/messages').then((c) => c.Messages)
      },
        {path:'HR',
                loadComponent: () => import('./demo/fase_dos/pages/resources/resources').then((c) => c.Resources)
      },
        {path:'time_off',
                loadComponent: () => import('./demo/fase_dos/components/approve-time-off/approve-time-off').then((c) => c.ApproveTimeOff)
      },
        {path:'time_off_admin',
                loadComponent: () => import('./demo/fase_dos/components/appr-admin-time-off/appr-admin-time-off').then((c) => c.ApprAdminTimeOff)
      },
        {
          path:'Finazas_Alumnos',
          loadComponent: () => import('./demo/fase_dos/pages/finanzas-alumnos/finanzas-alumnos').then((c) => c.FinanzasAlumnos)
         },{
         path:'Mis_Demos',
         loadComponent:()=> import('./demo/fase_dos/pages/mis-demos/mis-demos').then((d)=>  d.MisDemos)
          },
          {
            path:'admin_demos',
          loadComponent:()=> import('./demo/fase_dos/pages/demos-page/demos-page').then((d)=>  d.DemosPage)

          },
          {
            path:'prospects',
          loadComponent:()=> import('./demo/fase_dos/pages/prospects/prospects').then((d)=>  d.Prospects)

          },
    {
     path:'reportes_one/:reporte',
     loadComponent:()=> import('./demo/fase_dos/pages/pg-reportes/pg-reportes').then((d)=>  d.PgReportes)
     },
      {
     path:'demo_summary',
     loadComponent:()=> import('./demo/fase_dos/pages/report-done/report-done').then((d)=>  d.ReportDoneComponent)
     },{
     path:'demo_enroll_gone',
     loadComponent:()=> import('./demo/fase_dos/pages/report-enroll-gone/report-enroll-gone').then((d)=>  d.ReportEnrollGone)
     },{
     path:'Finazas_Empleados',
     loadComponent:()=> import('./demo/fase_dos/pages/finazas-employee/finazas-employee').then((d)=>  d.FinazasEmployee)
     },
        {
     path:'payroll',
     loadComponent:()=> import('./demo/fase_dos/components/payroll-summary/payroll-summary').then((d)=>  d.PayrollSummary)
     },  {
      path:'caja_chica',
      loadComponent:()=> import('./demo/fase_dos/pages/caja-chica/caja-chica').then((d)=>  d.CajaChica)
     }, {
      path:'caja_grande',
      loadComponent:()=> import('./demo/fase_dos/pages/caja-grande/caja-grande').then((d)=>  d.CajaGrande)
     },{
      path:'financial_report',
      loadComponent:()=> import('./demo/fase_dos/components/financial-report/financial-report').then((d)=>  d.FinancialReport)
     },
     {
      path:'admin_report',
      loadComponent:()=> import('./demo/fase_dos/pages/admin-reports/admin-reports').then((d)=>  d.AdminReports)
     }
    ]
  },
      {
    path: '',
    component: GuestLayoutComponent,
    //  canActivate: [AuthGuard], // ✅ protect admin layout
    children: [
      {
        path: 'login',
        loadComponent: () => import('./demo/pages/authentication/auth-login/auth-login.component').then((c) => c.AuthLoginComponent)
      },
      {
        path: 'register',
        loadComponent: () =>
          import('./demo/pages/authentication/auth-register/auth-register.component').then((c) => c.AuthRegisterComponent)
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
